import { useLocation } from 'react-router-dom'
import DeepLinkBannerMeta from './DeepLinkBannerMeta'
import Footer from './Footer'
import { Header } from './Header'
import { isPublicCheckoutPath } from './publicCheckoutRoute'

export default function Layout({ children }) {
  const location = useLocation()
  const isPublicCheckoutRoute = isPublicCheckoutPath(location.pathname)

  if (isPublicCheckoutRoute) {
    return (
      <div className="min-h-screen flex flex-col bg-customDark">
        <DeepLinkBannerMeta />
        <main className="flex-1">
          {children}
        </main>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex flex-col bg-customDark">
      <DeepLinkBannerMeta />
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  )
}
